import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// CHOIX D'UNE PHOTO DANS LE PANNEAU DE GAUCHE (correctif 4, 2026-10-16).
//
// Plus aucune fenetre ne s'ouvre sur la page : un clic sur un emplacement vide met ce panneau a la place de
// la bibliotheque, avec un bandeau qui dit POUR QUEL emplacement on choisit. Un clic sur une photo la place ;
// l'appelant propose ensuite automatiquement l'emplacement vide suivant (remplir 4 emplacements = 4 clics),
// et ferme le choix quand il n'en reste plus. Sur petit ecran, le meme panneau monte du bas en feuille
// (voir .atelier-panel.is-picking dans BookAtelierLuxe.css).
//
// Les photos pas encore utilisees passent en premier ; celles deja placees restent proposees (une photo peut
// servir deux fois), discretement marquees.
function AtelierPhotoPickPanel({ target, photos, usedItemIds, onPick, onUpload, uploading, error, onCancel }) {
  const { t } = useTranslation('atelier');

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape' && !uploading) { event.stopPropagation(); onCancel(); }
    };
    document.addEventListener('keydown', onKeyDown, true);
    return () => document.removeEventListener('keydown', onKeyDown, true);
  }, [onCancel, uploading]);

  const handleFile = (event) => {
    const [file] = Array.from(event.target.files || []);
    event.target.value = '';
    if (file) onUpload(file);
  };

  const unused = photos.filter((photo) => !usedItemIds.has(photo.id));
  const used = photos.filter((photo) => usedItemIds.has(photo.id));
  const ordered = [...unused, ...used];

  return (
    <div className="atelier-pick-panel" role="group" aria-label={t('pickPanel.banner', { target })}>
      <div className="atelier-pick-banner">
        <span>{t('pickPanel.banner', { target })}</span>
        <button type="button" onClick={onCancel} disabled={uploading}>{t('pickPanel.cancel')}</button>
      </div>

      <label className={`atelier-pick-upload ${uploading ? 'is-disabled' : ''}`}>
        {uploading ? t('photoPickerModal.uploading') : `+ ${t('pickPanel.import')}`}
        <input type="file" accept="image/*" onChange={handleFile} disabled={uploading} hidden />
      </label>
      {error && <p className="atelier-picker-error" role="alert">{error}</p>}

      {ordered.length > 0 ? (
        <div className="atelier-pick-grid">
          {ordered.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`atelier-pick-thumb ${usedItemIds.has(item.id) ? 'is-used' : ''}`}
              onClick={() => onPick(item.id)}
              disabled={uploading}
              aria-label={t('photoPickerModal.useThisPhoto')}
            >
              <img src={item.metadata?.thumbnailUrl || item.url} alt="" loading="lazy" draggable={false} />
              {usedItemIds.has(item.id) && <span className="atelier-pick-used">{t('pickPanel.used')}</span>}
            </button>
          ))}
        </div>
      ) : (
        <p className="atelier-picker-empty">{t('pickPanel.empty')}</p>
      )}
    </div>
  );
}

export default AtelierPhotoPickPanel;
